import { Icon } from '@iconify/react';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import peopleFill from '@iconify/icons-eva/people-fill';
import fileTextFill from '@iconify/icons-eva/file-text-fill';
// import shoppingBagFill from '@iconify/icons-eva/shopping-bag-fill';
// import lockFill from '@iconify/icons-eva/lock-fill';

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const SidebarConfig = [
  {
    title: 'Home',
    path: '/dashboard/app',
    icon: getIcon(pieChart2Fill),
  },
  {
    title: 'Batch',
    path: '/dashboard/batch',
    icon: getIcon(fileTextFill),
  },
  {
    title: 'Users',
    path: '/dashboard/users',
    icon: getIcon(peopleFill),
  },
  // {
  //   title: 'Supercapstones',
  //   path: '/dashboard/supercapstonepartner',
  //   icon: getIcon(peopleFill),
  // },
];

export default SidebarConfig;
